// extracted by mini-css-extract-plugin
export default {"component":"howTo_component__73Dlr","controls":"howTo_controls__9g3IG","summary":"howTo_summary__+AxON","control":"howTo_control__mUUnj"};